import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';

@Component({
    selector: 'app-registration-dialog',
    templateUrl: './registration-dialog.component.html',
    styleUrls: ['./registration-dialog.component.scss'],
    standalone: false
})
export class RegistrationDialogComponent {
  bidManagementURL: string = environment.bidManagementBaseUrl;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
  }

  navigateToBidManagement(targetURL: string): void {
    if (this.data.status === 'success') {
      window.location.href = targetURL;
    }
  }
}
